import React, { useEffect, useMemo, useState } from "react";
import "./index.scss";
import FaqItem from "../../FaqItem";
import { VehicleTableRow } from "../../VehicleTableRow";
import useFaq from "../../../Global/Api/Settings/faq.api";
import {Paginate} from "../../Paginate";

export default function FAQ() {
  const [page, setPage] = useState(1);
  const { faq, get } = useFaq(page);

  useEffect(() => {
    get();
  }, [page]);

  const renderFaq = useMemo(
    () =>
      faq?.data?.map((item, index) => (
        <FaqItem
          key={item?.id}
          id={item?.id}
          title={item?.question}
          description={item?.answer}
          is_open={item?.is_open}
        />
      )),
    [faq]
  );

  return (
    <div className="faq">
      <p className="faq__title">FAQ</p>
      <div className="faq__list">{renderFaq}</div>
      {faq?.totalPage > 1 && (
        <Paginate currentPage={page} setCurrentPage={setPage} pageCount={faq?.totalPage}/>
      )}
    </div>
  );
}
